import { render, staticRenderFns } from "./AnaliseDocumentacaoCredenciamento.vue?vue&type=template&id=52a86e4c&scoped=true"
import script from "./AnaliseDocumentacaoCredenciamento.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoCredenciamento.vue?vue&type=style&index=0&id=52a86e4c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a86e4c",
  null
  
)

export default component.exports